<template>
  <Slide>
    <h1>Gracias</h1>
  </Slide>
</template>

<script>
import Slide from "./Slide";

export default {
  name: "Summary",
  components: {
    Slide,
  },
};
</script>

<style scoped>
</style>